import { render, staticRenderFns } from "./LiefengTreeFn.vue?vue&type=template&id=57aced4f&scoped=true&"
import script from "./LiefengTreeFn.vue?vue&type=script&lang=js&"
export * from "./LiefengTreeFn.vue?vue&type=script&lang=js&"
import style0 from "./LiefengTreeFn.vue?vue&type=style&index=0&id=57aced4f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57aced4f",
  null
  
)

export default component.exports